import styled from "styled-components";

export const ReservationOptionWrapper = styled.div`
  width: calc(100% - 52px);
  border-radius: 12px;
  padding: 30px 15px 24px;
  background: #ffffff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;

  > .title {
    font-weight: 800;
    font-size: 20px;
    line-height: 140%;
    text-align: center;
    color: #202020;
  }
`;

export const ReservationOptionItemWrapper = styled.div`
  margin: 20px 0 30px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ReservationOptionItem = styled.div<{ isSelected: boolean }>`
  flex: 1;
  height: 50px;
  border-radius: 8px;
  border: 1px solid ${(p) => (p.isSelected ? "#6436E7" : "#B7B7B7")};
  background: ${(p) => (p.isSelected ? "#6436E7" : "#fff")};
  color: ${(p) => (p.isSelected ? "#fff" : "#000")};
  font-weight: 700;
  font-size: 15px;
  line-height: 50px;
  text-align: center;
  transition: all 0.2s;
`;

export const ReservationOptionButtonWrapper = styled.div`
  display: flex;
  width: 100%;
  gap: 8px;

  > .button {
    flex: 1;
    height: 48px;
    border-radius: 8px;
    color: var(--Purple-300, #6436e7);
    font-weight: 600;
    font-size: 15px;
    line-height: 48px;
    text-align: center;

    &.purple {
      color: #fff;
      background: #6436e7;
    }
  }
`;
